import { useRef, useState, useEffect, RefObject } from "react";

const useIntersectionObserver = (options = {}): [boolean, RefObject<HTMLDivElement>] => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(entry.isIntersecting);
      }
    }, options);

    const currentElement = elementRef.current;
    if (currentElement) observer.observe(currentElement);

    return () => observer.disconnect();
  }, [isVisible, options]);

  return [isVisible, elementRef];
};

export default useIntersectionObserver;
